export default __webpack_public_path__ + "static/media/inventMgmt1.0e1b76c2.png";